<template class="aa">
  <div class="sot-ds1"></div>
    <v-container class="center-content">
      <center>
        <div style="width: 95%;">
          <h1>Connect Your Discord Account</h1>
          <p>Follow these steps to link your Discord account to use the bot.</p>
        </div>
      </center>
  
      <v-alert
        v-if="showSuccessMessage"
        type="success"
        class="mt-4"
        border="end"
        elevation="2"
      >
        Your Discord account has been successfully connected!
      </v-alert>
  
      <v-card class="mt-5 mx-auto dc" max-width="600">
        <v-card-text style="text-align: center;">
        <p>discord.gg/vfpSjhmrTC</p>
        <br>
        <v-divider></v-divider>

        <img src="/bot-discord.jpg" width="100%">

        
        
          <br><br>
          <v-btn
            v-if="isAuthenticated"
            color="primary"
            block
            :href="discordAuthUrl"
          >
            Connect Discord
          </v-btn>
          <v-btn
            v-else
            color="primary"
            block
            :to="{ path: '/login' }"
          >
            Log in to Connect
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script>
import { mapGetters } from 'vuex';
import { useToast } from 'vue-toastification';

export default {
  data() {
    return {
      discordAuthUrl: '', // URL pour l'auth Discord
      isAuthenticated: localStorage.getItem('Authorization') !== null
    };
  },

  async created() {

    if (this.isAuthenticated) {
      await this.getDiscordAuthState();
    }

    // Affiche un toast si success=true dans l'URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('success') === 'true') {
      const toast = useToast();
      toast.success('Your Discord account has been successfully connected!');
    }
  },

  computed: {
    ...mapGetters(['backend']),
  },

  methods: {
    /**
     * Récupère le state de Discord depuis l'API et génère l'URL
     */
    async getDiscordAuthState() {
      const token = localStorage.getItem('Authorization');

      try {
        const response = await this.$axios.get(
          `${this.backend}/api/discord/getstate`,
          { headers: { Authorization: token } }
        );

        const CLIENT_ID = '1312369029801050192';
        const state = response.data;
        const REDIRECT_URI = `${this.backend}/api/discord/auth/discord`;
        this.discordAuthUrl = `https://discord.com/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
          REDIRECT_URI
        )}&state=${state}&response_type=code&scope=identify email`;
      } catch (error) {
        console.error('Error fetching Discord state:', error);
        this.discordAuthUrl = '';
      }
    },
  },
};
 </script>
  
  <style>
  .center-content {
    justify-content: center; 
    align-items: center; 
    height: 78vh; 
    margin-top: 11%;
    align-items: center;
  }

  .step-text{
    color:rgb(12, 69, 228)
  }
  .discordbtn{
  background-color: #1b1b1b;
  color: azure;
  border-radius: 10px;
  padding: 4px;
  font-size: 15px;
  text-align: center;
}

a{
  text-decoration: none;
  color: azure;
}


  </style>
  